import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwDeviationApiService } from 'app/services/deviations-api.service';
import * as deviationsActions from '../actions/deviations.actions';

@Injectable()
export class DeviationsEffects {
  loadDeviations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deviationsActions.loadDeviations),
      switchMap(({ loadOptions }) =>
        this.deviationApiService.getDeviations(loadOptions).pipe(
          map((response) =>
            deviationsActions.loadDeviationsSuccess({ response })
          ),
          catchError((error) =>
            of(deviationsActions.loadDeviationsFailure({ error }))
          )
        )
      )
    )
  );
  constructor(
    private actions$: Actions,
    private deviationApiService: MwDeviationApiService
  ) {}
}
